/**
 * Get a map of keys and values
 * @param keys - The keys to store in the map
 * @param values - The values to store in the map
 * @returns A map of keys and values
 *
 * example:
 * getMapStore<VariantColor>(['xqwe', 'frc', 'frc'], ['success', 'warning', 'danger'])
 * will return a map with the following entries:
 * {
 *   xqwe: 'danger',
 *   frc: 'warning',
 * }
 */
export function generateMapStore<T>(keys: string[], values: T[]) {
  if (values.length === 0)
    throw new Error('Values array is empty. Please provide a valid values array greater than 0')

  const map = new Map<string, T>()
  const defaultValue = values[0]

  for (const key of keys) {
    if (!map.get(key)) {
      // set the last value from the values array and remove it from the array if we have more than one value
      // or use the default value if we have no values
      map.set(key, values.length > 0 ? (values.pop() as T) : defaultValue)
    }
  }

  return map
}

export const generateColorForId = (id: number) => {
  // Create a hash based on the id
  const hash = Math.abs((id * 123456789) % 16777215).toString(16) // Basic hash, avoiding collision
  return `#${hash.padStart(6, '0')}` // Ensure it's a 6-digit hex code
}
